/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const CirclePower = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "12", cy: "12", r: "10" }],
    ["path", { d: "M12 12V7" }],
    ["path", { d: "M16 9a5 5 0 1 1-8 0" }]
  ]
];

export { CirclePower as default };
//# sourceMappingURL=circle-power.js.map
